import { useState, useEffect } from 'react';
import {
  readSiteSettingsFromStorage,
  SITE_BRANDING_UPDATED_EVENT,
} from '../utils/siteBranding';

const DEFAULT_NAME = 'Super Wear';

export default function useSiteBranding() {
  const [snapshot, setSnapshot] = useState(() => readSiteSettingsFromStorage() || {});

  useEffect(() => {
    const refresh = () => setSnapshot(readSiteSettingsFromStorage() || {});
    window.addEventListener(SITE_BRANDING_UPDATED_EVENT, refresh);
    return () => window.removeEventListener(SITE_BRANDING_UPDATED_EVENT, refresh);
  }, []);

  const siteName = snapshot.siteName || DEFAULT_NAME;
  const siteLogoUrl =
    typeof snapshot.siteLogoUrl === 'string' && snapshot.siteLogoUrl.trim()
      ? snapshot.siteLogoUrl.trim()
      : '';

  const sitePhone =
    typeof snapshot.sitePhone === 'string' && snapshot.sitePhone.trim()
      ? snapshot.sitePhone.trim()
      : '';
  const siteEmail =
    typeof snapshot.siteEmail === 'string' && snapshot.siteEmail.trim()
      ? snapshot.siteEmail.trim()
      : '';

  return { siteName, siteLogoUrl, sitePhone, siteEmail, raw: snapshot };
}
